export default {
    dashboardTitle: "MY DASHBOARD",
    dashboardSubtitle: "LATEST ORDERS",
    dashboardProducFrec: "FREQUENTLY ORDERED PRODUCTS",
    btnAddToCar: "Add to Cart",
    btnBack: "Back",
    btnOrderAgain: "Order Again",
    btnMoreOptions: "More Options",
    btnApprovarOrder: "Approve Order",
    btnCancelOrder: "Cancel Order",
    pedidoTitle: "Order Nro. ",
    guideTitle: "Guide Nro. ",
    invoinceTitle: "Invoice Nro. ",
    proformaTitle: "Solicitud de Proforma Nro. ",
    creditNoteTitle: "Credit Note Nro. ",
    ordersHistoryTitle: "Order History",
    opBtnMyOrders: "My Orders",
    opBtnPendingAprove: "Pending Approvals",
    opBtnGuies: "My Guides",
    opBtnInvoices: "My Invoices",
    btnSearch: "Search",
    menuDashboard: "My Dashboard",
    menuMyAccount: "My Account",
    menuQuickOrder: "Quick Order",
    menuOrderHistory: "Order History",
    btnProcedToCheckout: "Proceed to Checkout",
    cartTitle: "My Cart",
    defaultShoppingCart: "",
    empyCart: "Empty Cart",
    confEmpyCart: "We will remove all items. Do you want to continue?",
    yes: "Yes",
    shippingInfo: "Shipping Information",
    shippingAddress: "Shipping Address",
    shippingPhone: "Shipping Phone",
    shippingCity: "Shipping City",
    orderInfo: "Order Information",
    orderPurchaseNumber: "Purchase Order Number",
    orderPurchaseLogistic: "Logistics, Contact and Delivery Schedule",
    reviewOrder: "Review Order",
    btnModifOrder: "Modify My Order",
    paymentInfo: "Payment Information",
    salesCondition: "Sales Conditions",
    aggreCondition: "I agree to the conditions above",
    btnConfirOrder: "Confirm My Order",
    confirmTitle1: "Your order has been successfully processed.",
    confirmTitle2: "Your order has been sent for approval.",
    thankYouForInterest: "Thank you for your interest",
    emailConfirmationNotice1: "You will also receive a confirmation via email.",
    emailConfirmationNotice2: "Your order is pending supervisor approval. You will be notified once it is approved.",
    webOrderNumberLabel: "Your Order number is ",
    orderApproved1: "Approved",
    orderApproved2: "Pending supervisor approval",
    orderDate: "Order date",
    questionsOrComments: "If you have any questions or comments, please let us know.",
    continueShopping: "Continue shopping",
    printPaymentReceipt: "Print your receipt",
    allProducts: "Todos los productos",
    aproveeTitle: "Are you sure you want to approve this order?",
    aproveeText: "Once approved, this action cannot be undone.",
    yesAprovee: "Yes, approve",
    approveSuccessTitle: "Order approved!",
    approveSuccessTimePrefix: "Cancellation is available for",
    approveSuccessTimeSuffix: "on this order.",
    dayLabelSingular: "day",
    dayLabelPlural: "days",
    hourLabelSingular: "hour",
    hourLabelPlural: "hours",
    understood: "Understood",
    cancel: "Cancel",
    cancelOrderTitle: "Are you sure you want to cancel this order?",
    cancelOrderText: "Once cancelled, this action cannot be undone.",
    cancelOrderExpired: "The window to cancel this order has expired.",
    cancelOrderReasonPlaceholder: "Enter the reason for cancellation...",
    yesCancelOrder: "Yes, cancel",
    btnGenerarOrden: "Generate Order",
    btnApproveProforma: "Approve Proforma",
    approveProformaTitle: "Are you sure you want to Approve this Proforma request?",
    approveProformaText: "Once approved, this action cannot be undone.",
    menuDocumentsReceived: "Documents Received",
    menuOthersDocumentsReceived: "Others Documents Received",
    orderStatusTitle: "Order Tracking",
    orderStatusPending: "Still pending",
    status_EC_HECHO_label: "Order Placed",
    status_EC_HECHO_desc: "Your order was created in the online store.",
    status_EC_APROBADO_label: "Approved",
    status_EC_APROBADO_desc: "The order was approved by the Approver.",
    status_ULTRA_RECIBIDO_label: "Received",
    status_ULTRA_RECIBIDO_desc: "The order was received for processing.",
    status_ULTRA_GUIA_EMITIDA_label: "Waybill Issued",
    status_ULTRA_GUIA_EMITIDA_desc: "The shipping waybill was issued.",
    status_ULTRA_EN_RUTA_label: "On Route",
    status_ULTRA_EN_RUTA_desc: "The waybill was dispatched and is on its way.",
    status_EC_ENTREGADO_label: "Delivered",
    status_EC_ENTREGADO_desc: "The merchandise was received at the warehouse.",
    status_ULTRA_FACTURADO_label: "Invoiced",
    status_ULTRA_FACTURADO_desc: "The order was invoiced to the customer.",
    lblConditionSerec: "Debo y pagaré sin condiciones, a la orden de SEREC CIA.LTDA. El valor de esta orden, por concepto de los productos que aquí se detallan recibidos. \n" +
        "Favor cancelar a nombre de SEREC CIA.LTDA. mediante depósito o transferencia bancaria a la CUENTA CORRIENTE No.3045742304 del BANCO PICHINCHA o CUENTA CORRIENTE No.5005053109 BANCO BOLIVARIANO" +
        "Confirmar el pago al email documentos@serec-ecuador.com después de la fecha de vencimiento no se aceptan reclamos sobre el contenido de la presente orden." +
        "Por favor emitir y enviar el comprobante de retención al correo documentos@serec-ecuador.com dentro de los 5 días emitida la factura de acuerdo a la ley" +
        "ART.No.39LRT NO SE RECIBIRÁN RETENCIONES PASADO ESTE TIEMPO."
};